import { xTickStore } from '../../ng-services/xtick.store';

export type RsiGaugeRowConfig = { name: string; symbol: string }[];

export class RsiGaugeRowComponent {
    config!: RsiGaugeRowConfig;

    $onInit() {
        // fetch rsi
        this.config.forEach(({ symbol }) => xTickStore.fetchRsi14(symbol));
    }

    getRsi(symbol: string) {
        return xTickStore.rsi14.get(symbol) ?? 0;
    }
}

angular.module('tradersyard').component('tyRsiGaugeRow', {
    // language=HTML
    template: `
        <div style="display:flex;">
            <ty-rsi-gauge-chart mobx-autorun ng-repeat="config in $ctrl.config track by config.name" name="config.name" value="$ctrl.getRsi(config.symbol)"/>
        </div>
    `,
    controller: RsiGaugeRowComponent,
    bindings: {
        config: '<',
    },
});
